import React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"

const BusinessServiceItem = ({blok}) => {
  // console.log(blok)
  return (
    <div key={blok._uid} className={`py-5 w-full md:w-${blok.size}`} {...storyblokEditable(blok)}>
      <img className="w-full h-[300px] object-cover rounded-md px-5" loading="lazy" src={blok.image.filename} alt={blok.image.alt} />
      <div className="py-4 px-8">
        <div className="text-xl font-bold font-serif py-2">{blok.title}</div>
        <div className="" dangerouslySetInnerHTML={{ __html: renderRichText(blok.description) }} />
      </div>
    </div>
  )
}


const BusinessServiceSection = ({blok}) => {
  // console.log(blok)
  return (
    <section className="mt-20" {...storyblokEditable(blok)}>
       <h2 className="text-center font-bold text-3xl md:text-3xl my-6 md:my-10">{blok.title}</h2>
      <div className="container flex flex-row flex-wrap mx-auto">
        {blok.items?.map((blok, index) => (<BusinessServiceItem blok={blok} key={index} />))}
      </div>
    </section>
  )
}
  
export default BusinessServiceSection
